import * as fromContingentBundles from '../contingent/contingent-bundle.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const { selectAll } = fromContingentBundles.contingentBundleAdapter.getSelectors();

export const selectContingentBundleState = createFeatureSelector<fromContingentBundles.State>(fromContingentBundles.contingentBundleFeatureKey);

export const selectAllContingentBundles = createSelector(selectContingentBundleState, selectAll);

export const selectContingentBundleEntities = createSelector(selectContingentBundleState, selectAll);

export const selectContingentBundlesByName = (searchString: string) =>
    createSelector(selectContingentBundleEntities, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));
